document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-cod-buy-now]');
  if (!trigger || trigger.disabled) return;

  const variantId = trigger.dataset.variantId;
  if (!variantId) return;

  const spinner = trigger.querySelector('.loading__spinner');
  const errorElement = trigger.parentElement.querySelector('.cod-buy-now-error');

  trigger.setAttribute('disabled', 'disabled');
  trigger.classList.add('loading');
  if (spinner) spinner.classList.remove('hidden');
  if (errorElement) errorElement.hidden = true;

  fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
  })
    .then((response) => {
      if (!response.ok) throw new Error('add_to_cart_failed');
      window.location.href = `${window.Shopify.routes.root}checkout`;
    })
    .catch(() => {
      trigger.removeAttribute('disabled');
      trigger.classList.remove('loading');
      if (spinner) spinner.classList.add('hidden');
      if (errorElement) {
        errorElement.textContent = errorElement.dataset.error;
        errorElement.hidden = false;
      }
    });
});
